var transporters = {
    tim: {
        "name": "Timpex demo",
        "img": "tim-logo.svg",
        "url": "http://www.timpex.no"
    },
    tim_test: {
        "name": "Timpex test",
        "img": "tim-logo.svg",
        "url": "http://www.timpex.no"
    },
    arne: {
        "name": "Arne Demo",
        "img": "tim-logo.svg",
        "url": "http://www.timpex.no"
    },
    ove: {
        "name": "Ove demo",
        "img": "tim-logo.svg",
        "url": "http://www.timpex.no"
    },
    baard: {
        "name": "Bård demo",
        "img": "tim-logo.svg",
        "url": "http://www.timpex.no"
    },
    ronny: {
        "name": "Timpex demo",
        "img": "tim-logo.svg",
        "url": "http://www.timpex.no"
    },
    aslaug: {
        "name": "Aslaug demo",
        "img": "tim-logo.svg",
        "url": "http://www.timpex.no"
    },
    Aksnessaether: {
        "name": "Aksnessæther AS",
        "img": "Aksnessaether.png",
        "url": "https://www.akstrans.no/"
    },
    asco: {
        "name": "Asco Norge AS",
        "img": "asco-logo.png",
        "url": "http://www.ascoworld.com/"
    },
    atsk: {
        "name": "Ats Cargo,Kongsberg",
        "img": "atsk-logo.gif",
        "url": "http://atscargo.no/"
    },
    bama: {
        "name": "Bama Logistikk",
        "img": "bama-logo.png",
        "url": "https://bamalogistikk.no/"
    },
    srbkc: {
        "name": "Bergen Kran og Cargo",
        "img": "srbkc-logo.gif",
        "url": "https://www.bkoc.no/"
    },
    bts: {
        "name": "Bergen Transport Sentral",
        "img": "bts-logo.gif",
        "url": "http://bergentransportsentral.no/"
    },
    bostrand: {
        "name": "Bøstrand Transport",
        "img": "bostrand-logo.gif",
        "url": "http://www.bostrand.no/"
    },
    bostrandkc: {
        "name": "Bøstrand Kran & Container",
        "img": "bostrandkc-logo.gif",
        "url": "https://bostrand.no/kran-container/"
    },
    dsv: {
        "name": "DSV",
        "img": "dsv-logo.gif",
        "url": "http://www.no.dsv.com/"
    },
    eeklogistikk: {
        "name": "Eek Logistikk",
        "img": "eeklogistikk-logo.gif",
        "url": "http://eeklogistikk.no/"
    },
    jkt: {
        "name": "JK Transport AS",
        "img": "jkt-logo.gif",
        "url": "https://jktransport.no/"
    },
    khs: {
        "name": "Kjell Hansen Shipping",
        "img": "khs-logo.gif",
        "url": "http://www.khshipping.no/"
    },
    kjellhansen: {
        "name": "Kjell Hansen Shipping - R10",
        "img": "kjellhansen-logo.gif",
        "url": "http://www.khshipping.no/"
    },
    kn: {
        "name": "Kuehne + Nagel",
        "img": "kn-logo.gif",
        "url": "https://home.kuehne-nagel.com/"
    },
    lhs: {
        "name": "Lars Holm Shipping AS",
        "img": "lhs-logo.gif",
        "url": "http://holmshipping.no/"
    },
    lsa: {
        "name": "Leiv Sand Transport",
        "img": "lsa-logo.gif",
        "url": "https://leivsand.no/"
    },
    ltr: {
        "name": "Logi Trans",
        "img": "ltr-logo.gif",
        "url": "https://www.logitrans.no/"
    },
    ltrdk: {
        "name": "Logi Trans Denmark",
        "img": "ltrdk-logo.gif",
        "url": "https://www.logitrans.no/"
    },
    ltrho: {
        "name": "Logi Trans Holland",
        "img": "ltrho-logo.gif",
        "url": "https://www.logitrans.no/"
    },
    ltro: {
        "name": "Logi Trans Oslo",
        "img": "ltro-logo.gif",
        "url": "https://www.logitrans.no/"
    },
    ost: {
        "name": "Orkla Shipping & Transport AS",
        "img": "ost-logo.gif",
        "url": "http://orkla-shipping.no/"
    },
    rennesoy: {
        "name": "Rennesøy Trafikk",
        "img": "rennesoy.png",
        "url": "https://rennesoytrafikk.no/"
    },
    rennesoy_test: {
        "name": "Rennesøy Trafikk Test",
        "img": "rennesoy.png",
        "url": "https://rennesoytrafikk.no/"
    },
    sr_primecargo: {
        "name": "Prime Cargo",
        "img": "sr_primecargo-logo.gif",
        "url": "http://primecargo.no/"
    },
    sr: {
        "name": "SR Group AS",
        "img": "sr-logo.gif",
        "url": "http://sr-group.no/"
    },
    sra: {
        "name": "Alta Logistics",
        "img": "sra-logo.gif",
        "url": "http://altalogistics.com/"
    },
    hallingfrakt: {
        "name": "Halling Frakt",
        "img": "hallingfrakt-logo.gif",
        "url": "https://transportsiden.no/hallingfrakt/Timpex.Server/Js/timpex.js.traffic.trace.client.v2/index.html?id=hallingfrakt"
    },
    srtt: {
        "name": "Total Transport AS",
        "img": "total.jpeg",
        "url": "http://sr-group.no/"
    },
    thoresen_sped: {
        "name": "Thoresen Transport avd. Tønsberg AS",
        "img": "thoresen_sped-logo.png",
        "url": "http://www.thoresentransport.no/"
    },
    thoresen: {
        "name": "Thoresen Transport AS",
        "img": "thoresen-logo.png",
        "url": "http://www.thoresentransport.no/"
    },
    tine: {
        "name": "Tine",
        "img": "tine-logo.gif",
        "url": "https://www.tine.no/"
    },
    tine_test: {
        "name": "Tine",
        "img": "tine-logo.gif",
        "url": "https://www.tine.no/"
    },
    tine_mellomtransport: {
        "name": "Tine",
        "img": "tine-logo.gif",
        "url": "https://www.tine.no/"
    },
    tnr: {
        "name": "TNR",
        "img": "tnr-logo.png",
        "url": "http://tnrspedisjon.no/"
    },
    transferd: {
        "name": "Transferd",
        "img": "transferd-logo.gif",
        "url": "http://www.transferd.no/"
    },
    ttn: {
        "name": "Thermo-Transit Norge AS",
        "img": "ttn-logo.gif",
        "url": "http://www.thermo-transit.no/"
    },
    vd: {
        "name": "VD Transport",
        "img": "vd-logo.gif",
        "url": "http://www.vdtransport.no/"
    },
    veoymore: {
        "name": "Veøy Møre AS",
        "img": "veoymore-logo.jpg",
        "url": "http://veoymore.no/"
    },
    vts: {
        "name": "Voss Transportservice AS",
        "img": "vts-logo.gif",
        "url": "https://vts.no/"
    },
    ringsand: {
        "name": "Carmat AS",
        "img": "ringsand-logo.gif",
        "url": "https://ringsand.no/"
    },
    greencarrier: {
        "name": "Greencarrier",
        "img": "greencarrier-logo.png",
        "url": "https://greencarrier.com/"
    },
    toth_bhs: {
        "name": "Bergen Havneservice AS",
        "img": "toth_bhs-logo.png",
        "url": "http://bergenhavneservice.no/"
    },
    aquatran_no: {
        "name": "Pentagon Freight Services AS",
        "img": "aquatran_no-logo.png",
        "url": "http://pentagonfreight.com/"
    },
    vennesla: {
        "name": "Vennesla Transport AS-KRISTIANSAND S",
        "img": "vennesla.png",
        "url": "https://www.vennesla-transport.no/"
    },
    biversen: {
        "name": "B. Iversen Spedisjon AS",
        "img": "biversen.png",
        "url": "https://www.biversen.no/"
    },
    cargolinea: {
        "name": "Cargo Linea AS",
        "img": "cargolinea.png",
        "url": "https://www.cargolinea.no/"
    },
    norlog: {
        "name": "Nor-Log Thermo",
        "img": "norlog-logo.png",
        "url": "https://nor-log.no/"
    },
    norlogtransport: {
        "name": "Nor-Log Transport",
        "img": "norlogtransport-logo.png",
        "url": "https://nor-log.no/"
    },
    gasum: {
        "name": "Gasum ",
        "img": "gasum-logo.png",
        "url": "https://www.gasum.com/no/"
    },
    miniekspress: {
        "name": "Miniekspress Thermo AS",
        "img": "miniekspress-logo.svg",
        "url": "https://miniekspress.no"
    },
    miniekspressfinnmark: {
        "name": "Miniekspress Finnmark AS",
        "img": "miniekspressfinnmark.png",
        "url": "https://miniekspress.no"
    },
    miniekspresstromso: {
        "name": "Miniekspress Tromsø AS",
        "img": "miniekspresstromso.png",
        "url": "https://miniekspress.no"
    },
    andersen: {
        "name": "Andersen Transport AS",
        "img": "andersen-logo.png",
        "url": "https://andersentr.no/"
    },
    suldal: {
        "name": "Suldal Transport AS",
        "img": "suldal-logo.png",
        "url": "https://suldaltransport.no/"
    },
    tonnesbilan: {
        "name": "Tonnesbilan AS",
        "img": "tonnesbilan-logo.jpg",
        "url": "https://transportsiden.no/tonnesbilan/Timpex.Server/Js/timpex.js.traffic.trace.client.v2/index.html?id=tonnesbilan&traceNo="
    },
    nst: {
        "name": "Norrland Spedition & Transportation AS",
        "img": "nst-logo.jpg",
        "url": "http://transportsiden.no/nst/Timpex.Server/Js/timpex.js.traffic.trace.client.v2/index.html?id=nst&traceNo="
    },
    veitransport: {
        "name": "Veitransport AS",
        "img": "veitransport.png",
        "url": "https://www.veitransport.no/"
    },
    rogalandkran: {
        "name": "Rogaland Kran & Transport",
        "img": "rogalandkran-logo.png",
        "url": "https://rogalandkran.no/"
    },
    vognmand: {
        "name": "Vognmand Steen M. Hansen",
        "img": "vognmand-logo.jpg",
        "url": "http://www.smhtransport.dk/"
    },
    jas: {
        "name": "JAS",
        "img": "jas-logo.png",
        "url": "https://www.jas.com/"
    }
}

module.exports = transporters;
